var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { Button, Chip, Modal, ModalDialog, ModalClose, Typography, Box, Stack } from '@mui/joy';
import { useCallAnalytics } from '../../data/hooks/useCallAnalytics';
export var ExportSection = function (_a) {
    var dateRange = _a.dateRange, selectedFlow = _a.selectedFlow, customStartDate = _a.customStartDate, customEndDate = _a.customEndDate, selectedBuyer = _a.selectedBuyer;
    var _b = useCallAnalytics(), getCardMetrics = _b.getCardMetrics, cardMetrics = _b.cardMetrics, exportCallAnalytics = _b.exportCallAnalytics;
    var _c = useState([]), selectedTags = _c[0], setSelectedTags = _c[1];
    var _d = useState(false), isModalOpen = _d[0], setIsModalOpen = _d[1];
    var _e = useState([]), availableTags = _e[0], setAvailableTags = _e[1];
    useEffect(function () {
        var fetchTags = function () { return __awaiter(void 0, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, getCardMetrics(dateRange, selectedFlow, customStartDate, customEndDate, selectedBuyer)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.error('Failed to fetch tags:', error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        fetchTags();
    }, [dateRange, selectedFlow, customStartDate, customEndDate, selectedBuyer]);
    useEffect(function () {
        if (cardMetrics === null || cardMetrics === void 0 ? void 0 : cardMetrics.tags) {
            setAvailableTags(cardMetrics.tags.map(function (tagObj) { return tagObj.tag; }));
        }
    }, [cardMetrics]);
    var handleExport = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, exportCallAnalytics(dateRange, selectedFlow, customStartDate, customEndDate, selectedBuyer, selectedTags)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _a.sent();
                    console.error('Failed to export call analytics:', error_2);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleAddTag = function (tag) {
        if (!selectedTags.includes(tag)) {
            setSelectedTags(__spreadArray(__spreadArray([], selectedTags, true), [tag], false));
        }
    };
    var handleRemoveTag = function (tagToRemove) {
        setSelectedTags(selectedTags.filter(function (tag) { return tag !== tagToRemove; }));
    };
    return (_jsxs(Box, __assign({ sx: { display: 'flex', alignItems: 'center', gap: 2 } }, { children: [_jsx(Button, __assign({ variant: "solid", color: "primary", onClick: function () { return availableTags.length > 0 ? setIsModalOpen(true) : handleExport(); }, size: "sm" }, { children: "Export" })), availableTags.length > 0 && (_jsx(Modal, __assign({ open: isModalOpen, hideBackdrop: true, onClose: function () { return setIsModalOpen(false); } }, { children: _jsxs(ModalDialog, { children: [_jsx(ModalClose, {}), _jsx(Typography, __assign({ level: "h4" }, { children: "Select Tags" })), _jsx(Box, __assign({ sx: { mt: 2 } }, { children: _jsx(Stack, __assign({ direction: "row", spacing: 1, sx: { flexWrap: 'wrap', gap: 1 } }, { children: availableTags.map(function (tag) { return (_jsx(Chip, __assign({ variant: selectedTags.includes(tag) ? 'solid' : 'outlined', color: "primary", onClick: function () { return handleAddTag(tag); }, sx: { cursor: 'pointer' } }, { children: tag }), tag)); }) })) })), selectedTags.length > 0 && (_jsxs(Box, __assign({ sx: { mt: 2 } }, { children: [_jsx(Typography, __assign({ level: "body-sm", sx: { mb: 1 } }, { children: "Selected Tags:" })), _jsx(Stack, __assign({ direction: "row", spacing: 1, sx: { flexWrap: 'wrap', gap: 1 } }, { children: selectedTags.map(function (tag) { return (_jsx(Chip, __assign({ variant: "soft", color: "primary", endDecorator: _jsx(Box, __assign({ onClick: function () { return handleRemoveTag(tag); }, sx: { cursor: 'pointer', ml: 0.5 } }, { children: "\u00D7" })) }, { children: tag }), tag)); }) }))] }))), _jsxs(Box, __assign({ sx: { mt: 3, display: 'flex', justifyContent: 'flex-end', gap: 1 } }, { children: [_jsx(Button, __assign({ variant: "outlined", color: "neutral", onClick: function () { return setIsModalOpen(false); }, size: "sm" }, { children: "Cancel" })), _jsx(Button, __assign({ variant: "solid", color: "primary", onClick: handleExport, size: "sm" }, { children: "Export" }))] }))] }) })))] })));
};
